var _style, _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000163032505802842877210000014067504924515363243_);}\n\t.st1{clip-path:url(#SVGID_00000001645886328333086260000006579601705623576449_);fill:#009246;}\n\t.st2{clip-path:url(#SVGID_00000001645886328333086260000006579601705623576449_);fill:#F1F2F1;}\n\t.st3{clip-path:url(#SVGID_00000001645886328333086260000006579601705623576449_);fill:#CE2B37;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M85.4,14.6c19.5,19.5,19.5,51.2,0,70.7c-19.5,19.5-51.2,19.5-70.7,0c-19.5-19.5-19.5-51.2,0-70.7 C34.2-4.9,65.8-4.9,85.4,14.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000136391786022655549350000001346727340450683798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ITALY_1_",
    style: {
      clipPath: "url(#SVGID_00000136391786022655549350000001346727340450683798_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000024702388563699489620000012536183255944800131_",
    x: -36.7,
    y: -0.6,
    width: 173.3,
    height: 101.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002371922914770992630000013260522603765702030_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024702388563699489620000012536183255944800131_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -36.7,
    y: -0.6,
    style: {
      clipPath: "url(#SVGID_00000002371922914770992630000013260522603765702030_)",
      fill: "#009246"
    },
    width: 69.4,
    height: 101.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    y: -0.6,
    style: {
      clipPath: "url(#SVGID_00000002371922914770992630000013260522603765702030_)",
      fill: "#F1F2F1"
    },
    width: 34.6,
    height: 101.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.3,
    y: -0.6,
    style: {
      clipPath: "url(#SVGID_00000002371922914770992630000013260522603765702030_)",
      fill: "#CE2B37"
    },
    width: 69.4,
    height: 101.1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.c917716c12eb8352c1089fb168b51177.svg";
export { ForwardRef as ReactComponent };